import "../../css/company-financials.css";

import { Button, Table, Tooltip, Checkbox } from "antd";
import { useCallback, useMemo, useState } from "react";
import { emdash, toDollar } from "../../utils/Constants/systemSetting";
import { exportToCSV } from "../../utils/ExecutiveData/csvExport";
import FinancialBarGraph from "./FinancialBarGraph";

import metricHoverTexts from "./metricDetails/metricHoverTexts.json";
import metricCategories from "./metricDetails/metricCategories.json";

export const FinancialTable = ({
  rawData,
  backendDataName,
  subTableNames,
  ticker,
  valuesKey,
  dataPeriodTypeSelected,
  useCatgories,
  hiddenSubTables,
  setHiddenSubTables,
  monitaryUnitSelected,
  loading,
  peerGroupTable = false,
  currentFiscalYearSelected = null,
  cohortTableTickers = [],
  peerQuarterSelected = undefined,
  cohortSelected = "",
}) => {
  const handleTableSectionClick = (subTableName) => {
    if (hiddenSubTables.includes(subTableName)) {
      setHiddenSubTables(
        hiddenSubTables.filter((item) => item !== subTableName),
      );
    } else {
      setHiddenSubTables([...hiddenSubTables, subTableName]);
    }
  };
  function toTitleCase(str) {
    return str.replace(
      /[A-Za-z]+/g,
      (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    );
  }
  const [checkedRowsForExport, setCheckedRowsForExport] = useState({});

  const renderFiscalData = (text, record) => {
    let revisedText = text;

    if (revisedText) {
      if (record?.metricDetails?.isCurrency) {
        //Handle Currency
        let decimalPlaces = 0;
        if (parseFloat(text) !== parseInt(text)) {
          decimalPlaces = 2;
        }
        const numericalText = parseFloat(text);
        const abbreviatedText =
          numericalText /
          (monitaryUnitSelected === "B"
            ? 1e9
            : monitaryUnitSelected === "M"
              ? 1e6
              : monitaryUnitSelected === "K"
                ? 1e3
                : 1);
        revisedText = toDollar(abbreviatedText, decimalPlaces, true);
      } else if (
        ["number", "%", "ratio"].includes(record?.metricDetails?.metricFormat)
      ) {
        //Handle plain numbers, ratios and percentages
        revisedText = revisedText.toLocaleString();
        if (record?.metricDetails?.metricFormat === "%") {
          revisedText = revisedText * 100;
          revisedText = revisedText.toFixed(2);
          revisedText += "%";
        }

        if (revisedText.toString() === "-0") {
          // correct -0 data points
          revisedText = 0;
        }
      } else {
        // Format with commas regardless of metricFormat as long as it is a valid type
        // Sometimes fiscal.ai returns null for metricFormat
        if (
          typeof revisedText === "string" ||
          typeof revisedText === "number"
        ) {
          revisedText = parseFloat(revisedText).toLocaleString();
        }
      }
    }

    if (!revisedText && parseInt(revisedText) !== 0 && record?.metricDetails) {
      // Handle null values
      revisedText = emdash;
    }

    return (
      // <span>
      //   <Tooltip
      //     title={
      //       <div>
      //         <div>
      //           Raw Value:{" "}
      //           {typeof text === "object" ? JSON.stringify(text) : text}{" "}
      //         </div>{" "}
      //         <div>
      //           Details: {JSON.stringify(record?.metricDetails, null, 2)}{" "}
      //         </div>{" "}
      //       </div>
      //     }
      //   >
      <div>{revisedText}</div>
      //   </Tooltip>
      // </span>
    );
  };

  const [currentMetricCompared, setCurrentMetricCompared] = useState("");
  const [currentMetricData, setCurrentMetricData] = useState({});

  const [prevBackendDataName, setPrevBackendDataName] =
    useState(backendDataName);

  useMemo(() => {
    if (backendDataName !== prevBackendDataName) {
      setCurrentMetricCompared("");
      setPrevBackendDataName(backendDataName);
    }
  }, [backendDataName, prevBackendDataName]);

  const generateColumns = (header, periodsAvailable) => {
    let currentMetricFound = "";
    const columns = [
      {
        title: `${header || "Metric"}`,
        dataIndex: `${header || "metric"}`,
        key: `${header || "metric"}`,
        onCell: (_, index) => ({
          colSpan: index > 1 ? 5 : 3,
        }),
        align: "center",
        width: "165px",
        render: (text, record, index) => {
          const isSpecial = record.isNewSection;

          if (!currentMetricCompared && !currentMetricFound && !isSpecial) {
            currentMetricFound = text;
            setCurrentMetricCompared(text);
            setCurrentMetricData(record);
          }
          return (
            <span>
              <div
                style={{
                  cursor: "pointer",
                  // cursor: metricHoverTexts.some(
                  //   (item) => item.metricName === text,
                  // )
                  //   ? "help"
                  //   : "",
                  textAlign: isSpecial ? "left" : "left",
                  marginLeft:
                    record.headers && record.headers.length > 1
                      ? record.headers.length * 10
                      : 0,
                  fontWeight: currentMetricCompared === text ? "bolder" : "",
                  fontSize: currentMetricCompared === text ? "12pt" : "",
                  display: "flex",
                }}
              >
                {isSpecial && (
                  <span
                    style={{
                      marginRight: 4,
                      marginLeft: !hiddenSubTables.includes(text) ? 0 : 1,
                      fontSize: 8,
                    }}
                  >
                    {!hiddenSubTables.includes(text) ? "▼ " : "▶ "}
                  </span>
                )}
                {!isSpecial && backendDataName === "Company Ratios" && (
                  <span>
                    <Tooltip
                      title={`${
                        !checkedRowsForExport[text] &&
                        Object.values(checkedRowsForExport).filter(
                          (item) => !!item,
                        ).length >= 15
                          ? "CSV export for Company Ratios is limited to 15 ratios at a time"
                          : `${
                              !checkedRowsForExport[text]
                                ? "Include ratio in"
                                : "Remove ratio from"
                            }
                       CSV export${!checkedRowsForExport[text] ? "?" : ""}`
                      }  `}
                      overlayClassName="tooltip-pass-through"
                    >
                      <Checkbox
                        checked={!!checkedRowsForExport[text]}
                        disabled={
                          !checkedRowsForExport[text] &&
                          Object.values(checkedRowsForExport).filter(
                            (item) => !!item,
                          ).length >= 15
                        }
                        onChange={(e) => {
                          const updated = {
                            ...checkedRowsForExport,
                            [text]: e.target.checked,
                          };
                          setCheckedRowsForExport(updated);
                        }}
                        style={{ marginRight: 15 }}
                      />
                    </Tooltip>
                  </span>
                )}

                <Tooltip
                  title={
                    metricHoverTexts.some((item) => item.metricName === text)
                      ? toTitleCase(
                          metricHoverTexts
                            .find((item) => item.metricName === text)
                            .metricHover.replace("ratio_", "")
                            .replace("calculated_", "")
                            .replaceAll("_", " "),
                        )
                      : ""
                  }
                  overlayClassName="tooltip-pass-through"
                >
                  <div
                    style={{ flexGrow: 1 }}
                    onClick={() => {
                      if (!isSpecial) {
                        setCurrentMetricCompared(text);
                        setCurrentMetricData(record);
                      }
                    }}
                  >
                    {text}
                  </div>
                </Tooltip>
              </div>
            </span>
          );
        },
      },
    ];

    for (const periodAvailable of periodsAvailable) {
      const fiscalYear = periodAvailable.fiscalYear;
      const fiscalQuarter = periodAvailable?.calendarQuarter;
      const reportDate = new Date(periodAvailable.reportDate);
      const reportDateFormatted = reportDate.toLocaleString("en-US", {
        month: "short",
        year: "numeric",
      });

      if (!peerGroupTable) {
        if (columns.length <= 12) {
          columns.push({
            title:
              dataPeriodTypeSelected === "annual"
                ? `FY ${fiscalYear}`
                : reportDateFormatted,
            dataIndex: periodAvailable.periodId,
            key: periodAvailable.periodId,
            align: "center",
            render: (text, record) => renderFiscalData(text, record),
          });
        }
      } else if (
        dataPeriodTypeSelected === "latest" ||
        (dataPeriodTypeSelected === "annual" &&
          parseInt(fiscalYear) === currentFiscalYearSelected) ||
        (!["annual", "latest"].includes(dataPeriodTypeSelected) &&
          parseInt(fiscalYear) === currentFiscalYearSelected &&
          fiscalQuarter === peerQuarterSelected)
      ) {
        for (const ticker of Object.keys(rawData[backendDataName])) {
          if (Object.keys(rawData[backendDataName][ticker]?.result).length) {
            columns.push({
              title: ticker,
              dataIndex: ticker,
              key: ticker,
              align: "center",
              render: (text, record) => renderFiscalData(text, record),
            });
          }
        }
      }
    }

    return columns;
  };

  const getMetricID = (metric) => {
    return (
      metric.metricId ||
      metric.ratioId ||
      metric.standardizedMetricId ||
      metric.asReportedMetricId
    );
  };

  const generateDataSet = useCallback(
    (
      fiscalData,
      dataName,
      ticker,
      valuesKey = "metricValues",
      subTableName = null,
      fiscalYearNeeded = "2024",
      currentDataSources = [],
    ) => {
      const finalData = [];

      const allMetricValues =
        fiscalData?.[dataName]?.[ticker]?.result?.data?.[0]?.[valuesKey];

      if (typeof allMetricValues !== "object") {
        return [];
      }

      const getIndexOfMetricId = (metricId) => {
        const metricDetails = metricCategories.find(
          (item) => metricId === item.ID,
        );
        return metricCategories.indexOf(metricDetails);
      };

      const allMetricDetails =
        backendDataName === "Company Ratios"
          ? fiscalData[dataName][ticker].result.metrics.sort(
              (a, b) =>
                getIndexOfMetricId(a.ratioId) - getIndexOfMetricId(b.ratioId),
            )
          : fiscalData[dataName][ticker].result.metrics;

      allMetricDetails.forEach((metricDetails) => {
        const metricId = getMetricID(metricDetails);
        const metricCategoryDetails =
          backendDataName === "Company Ratios"
            ? metricCategories?.[getIndexOfMetricId(metricId)]
            : null;

        if (metricDetails?.Remove) return;

        if (
          !hiddenSubTables.includes(subTableName) &&
          ((!useCatgories &&
            ((metricDetails?.headers &&
              metricDetails.headers.includes(subTableName)) ||
              (subTableName === "Other" &&
                (!metricDetails?.headers ||
                  metricDetails.headers.length === 0)))) ||
            (useCatgories &&
              ((metricCategoryDetails?.Category &&
                metricCategoryDetails.Category === subTableName) ||
                (subTableName === "Other" &&
                  !metricCategoryDetails?.Category))))
        ) {
          const newData = {
            [dataName || "metric"]: metricDetails?.metricName || "",
            metricDetails: metricDetails,
            headers: metricDetails.headers,
          };
          if (!peerGroupTable) {
            for (const dataForPeriod of fiscalData?.[dataName]?.[ticker]?.result
              ?.data) {
              const dataForPeriodMetricValue =
                dataForPeriod[valuesKey]?.[metricId];
              newData[dataForPeriod.periodId] =
                typeof dataForPeriodMetricValue === "object" &&
                dataForPeriodMetricValue?.value !== null
                  ? dataForPeriodMetricValue.value
                  : dataForPeriodMetricValue?.value === null
                    ? ""
                    : dataForPeriodMetricValue &&
                        dataForPeriodMetricValue !== null
                      ? dataForPeriodMetricValue
                      : "";
            }
          } else {
            for (const tick of [ticker, ...cohortTableTickers]) {
              if (Array.isArray(fiscalData?.[dataName]?.[tick]?.result?.data)) {
                for (const dataForPeriod of fiscalData?.[dataName]?.[tick]
                  ?.result?.data) {
                  if (
                    dataPeriodTypeSelected === "latest" ||
                    (dataPeriodTypeSelected === "annual" &&
                      parseInt(dataForPeriod.fiscalYear) ===
                        currentFiscalYearSelected) ||
                    (!["annual", "latest"].includes(dataPeriodTypeSelected) &&
                      parseInt(dataForPeriod.fiscalYear) ===
                        currentFiscalYearSelected &&
                      dataForPeriod?.calendarQuarter === peerQuarterSelected)
                  ) {
                    const dataForPeriodMetricValue =
                      dataForPeriod[valuesKey]?.[metricId];
                    newData[tick] =
                      typeof dataForPeriodMetricValue === "object" &&
                      dataForPeriodMetricValue?.value !== null
                        ? dataForPeriodMetricValue.value
                        : dataForPeriodMetricValue?.value === null
                          ? ""
                          : dataForPeriodMetricValue &&
                              dataForPeriodMetricValue !== null
                            ? dataForPeriodMetricValue
                            : "";
                  }
                }
              }
            }
          }

          finalData.push(newData);
        }
      });
      if (finalData.length || hiddenSubTables.includes(subTableName)) {
        if (
          subTableName !== "Other" ||
          subTableNames.length > 1 ||
          hiddenSubTables.length >= 1
        ) {
          finalData.unshift({
            [dataName || "metric"]: subTableName,
            colSpan: 2,
            isNewSection: true,
          });
        }
      }

      return finalData;
    },
    [
      hiddenSubTables,
      backendDataName,
      subTableNames,
      peerGroupTable,
      dataPeriodTypeSelected,
      currentFiscalYearSelected,
      cohortTableTickers,
      peerQuarterSelected,
      useCatgories,
    ],
  );

  const periodsAvailable =
    !rawData?.[backendDataName]?.[ticker]?.result?.data ||
    !rawData?.[backendDataName]?.[ticker]?.result?.data.length > 0
      ? []
      : rawData?.[backendDataName]?.[ticker]?.result?.data;
  const columns = generateColumns(backendDataName, periodsAvailable);

  const consolidatedDataSources = useMemo(() => {
    const dataSources = [];

    let revisedSubTableNames = [];
    if (backendDataName === "Company Ratios") {
      revisedSubTableNames = [
        ...new Set(metricCategories.map((item) => item.Category)),
      ];
    } else {
      revisedSubTableNames = [
        ...subTableNames.filter((item) => item !== "Other"),
        "Other",
      ];
    }

    for (const subTableName of revisedSubTableNames) {
      const dataSource = generateDataSet(
        rawData,
        backendDataName,
        ticker,
        valuesKey,
        subTableName,
        subTableNames,
      );
      dataSources.push(dataSource);
    }
    return dataSources;
  }, [
    ticker,
    rawData,
    subTableNames,
    backendDataName,
    valuesKey,
    generateDataSet,
  ]);

  // CSV export
  const formatDataForCSVexport = useCallback(() => {
    const dataForExport = consolidatedDataSources.flat(1);
    const financialTableOutputData = [];
    if (dataForExport?.length) {
      financialTableOutputData.push(
        ...dataForExport?.map((item) => {
          return { ...item };
        }),
      );
    }
    const financialTableHeaders = [];
    columns.forEach((item) => {
      if (!financialTableHeaders.includes(item.dataIndex)) {
        financialTableHeaders.push(item.dataIndex);
      }
    });
    const filteredData = financialTableOutputData.filter((item, index) => {
      if (backendDataName !== "Company Ratios") {
        return true;
      }
      if (index > 0 && checkedRowsForExport?.[item?.[backendDataName]]) {
        return true;
      }
      return false;
    });
    if (!filteredData.length) {
      return [
        {
          [`"${backendDataName}"`]: "Select one or more metrics for CSV export",
        },
      ];
    }

    const formattedFinancialData = filteredData.map((item) => {
      const formattedItem = {};
      columns.slice(0, 31).forEach((keyDetails, index) => {
        if (keyDetails?.dataIndex) {
          formattedItem[
            index === 0 ? `"${backendDataName}"` : `"${keyDetails.title}"`
          ] = item?.[keyDetails.dataIndex]
            ? backendDataName === keyDetails.title &&
              subTableNames.includes(item[keyDetails.dataIndex])
              ? `-- Category: ${item[keyDetails.dataIndex]} --`
              : item[keyDetails.dataIndex].toString().includes(",")
                ? item[keyDetails.dataIndex].replaceAll(",", "‚") //Replace commas with non-CSV splitting commas
                : item[keyDetails?.dataIndex]
            : "";
        }
      });
      return formattedItem;
    });
    return formattedFinancialData;
  }, [
    backendDataName,
    columns,
    subTableNames,
    consolidatedDataSources,
    checkedRowsForExport,
  ]);

  const [year, setYear] = useState(2024);

  const dataFormattedForBarGraph = useCallback(() => {
    if (!Object.keys(currentMetricData).length) {
      return [
        {
          name: "test",
          measureValue: 1,
        },
      ];
    }
    const adjustedColumns = peerGroupTable
      ? [...columns]
      : [...columns].reverse();

    return adjustedColumns.map((columnData) => {
      const dataKey = columnData.dataIndex;
      return {
        name: columnData.title,
        measureValue: currentMetricData[dataKey],
        measurePercentile: "",
      };
    });
  }, [peerGroupTable, columns, currentMetricData]);

  const tableHeight = "calc(100vh - 320px)";

  return (
    <div style={{ width: "100%", marginLeft: 5 }}>
      <FinancialBarGraph
        year={""}
        executive={{ name: ticker }}
        measure={{
          title: currentMetricCompared,
          dataType:
            currentMetricData?.metricDetails?.metricFormat === "%"
              ? "percent"
              : currentMetricData?.metricDetails?.metricFormat === "number" ||
                  currentMetricCompared.includes(" Price")
                ? "dollar"
                : currentMetricData?.metricDetails?.metricFormat,
        }}
        cohortTableSelector={cohortSelected}
        sortedTableKeys={dataFormattedForBarGraph()}
        tablePagination={0}
        customXaxisTitle={
          peerGroupTable
            ? "Peer Group Ticker"
            : dataPeriodTypeSelected === "annual"
              ? "Fiscal Year"
              : dataPeriodTypeSelected === "semi-annual"
                ? "Semi-Annual Period"
                : dataPeriodTypeSelected === "quarterly"
                  ? "Quarter"
                  : dataPeriodTypeSelected === "latest"
                    ? "Latest"
                    : dataPeriodTypeSelected.toUpperCase()
        }
        isPeerGroupGraph={peerGroupTable}
      />

      {!false && (
        <div style={{ width: "100%" }}>
          <Button
            style={{
              marginBottom: backendDataName !== "Company Ratios" ? 10 : 0,
              marginLeft: "-1.5px",
            }}
            onClick={() =>
              exportToCSV(
                formatDataForCSVexport(),
                `${ticker} ${backendDataName} ${
                  new Date().toString().split("GMT-")[0]
                }.csv`,
              )
            }
          >
            Export {ticker} {peerGroupTable ? "+ Peer Group" : ""}{" "}
            {backendDataName.replace("Standardized", "")} as CSV
            {backendDataName === "Company Ratios" ? "*" : ""}
          </Button>
          {backendDataName === "Company Ratios" && (
            <p
              style={{
                marginBottom: Object.values(checkedRowsForExport).some(
                  (item) => !!item,
                )
                  ? 0
                  : 10,
                marginLeft: 5,
              }}
            >
              * Financial Ratio Exports are limited to 15 metrics at a time.
            </p>
          )}

          {Object.values(checkedRowsForExport).some((item) => !!item) && (
            <Button
              style={{ marginBottom: 15, marginLeft: 1.5 }}
              size={"small"}
              onClick={() => setCheckedRowsForExport({})}
            >
              Clear current metric selection
            </Button>
          )}
          {cohortTableTickers.length > 30 && (
            <p
              style={{
                marginBottom: 5,
                marginLeft: 5,
              }}
            >
              All financial exports are limited to 30 companies or less. Your
              current peer group contains {cohortTableTickers.length} companies.
            </p>
          )}
        </div>
      )}
      <p style={{}}>
        Click a metric name to compare
        {peerGroupTable ? " against peers" : " over time"}.
      </p>
      {monitaryUnitSelected !== "$" && (
        // peerFinancialOptionSelected &&
        // peerFiscalYearSelected &&
        <p style={{}}>
          All dollar amounts are shown in{" "}
          {monitaryUnitSelected === "B"
            ? "billions"
            : monitaryUnitSelected === "M"
              ? "millions"
              : "thousands"}
          .
        </p>
      )}
      <Table
        columns={columns}
        dataSource={consolidatedDataSources.flat(1)}
        rowClassName={(record) =>
          record.isNewSection
            ? hiddenSubTables.includes(record?.[backendDataName])
              ? "special-row hidden"
              : "special-row"
            : ""
        }
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              if (record?.isNewSection) {
                handleTableSectionClick(record?.[backendDataName]);
              }
            },
          };
        }}
        scroll={{ y: tableHeight }}
        pagination={false}
        size={"small"}
        loading={loading}
        // scroll={{ x: "max-content" }}
      />
    </div>
  );
};
